import { parseAsString, useQueryState } from "nuqs";

import { AdminGridTable } from "../../../components/admin-console/admin-grid-table";
import { ROAD_COLUMNS, usePageStore } from "../constructor-roads-page.lib";
import { useConstructorRoads } from "../hooks/use-constructor-roads";

const searchParser = parseAsString.withDefault("").withOptions({ clearOnDefault: true });

/** Таблица дорог конструктора: быстрый поиск из URL и меню строки (редактирование — через стор). */
export const ConstructorRoadsTable = () => {
  const store = usePageStore()!;
  const { roads, isLoading } = useConstructorRoads();
  const [search] = useQueryState("search", searchParser);

  return (
    <AdminGridTable
      tableId="admin-roads-table"
      columns={ROAD_COLUMNS}
      rows={roads}
      isLoading={isLoading}
      quickFilterText={search ?? undefined}
      onRowMenu={(road) => store.setPopupAction({ type: "edit", road })}
      className="h-[32rem]"
    />
  );
};
